var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 56,
    viewBox: "0 0 248 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5967_44777)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.321 5.13599H104.465C99.2471 5.13599 95.0156 9.37288 95.0156 14.598V41.8939C95.0156 47.119 99.2471 51.3559 104.465 51.3559H138.321C143.539 51.3559 147.771 47.119 147.771 41.8939V14.598C147.771 9.37288 143.539 5.13599 138.321 5.13599ZM146.047 38.5604C146.047 44.269 143.739 48.8708 138.321 48.8708L104.608 49.1676C99.1904 49.1676 96.7607 45.9721 96.7607 40.2635V23.6231C96.7607 17.9145 97.0996 13.2875 102.517 13.2875H140.422C145.839 13.2875 146.047 17.9145 146.047 23.6231V38.5604Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 0.544034,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.815 0.746338H106.81C106.27 0.746338 105.832 1.18497 105.832 1.72604V8.39735C105.832 8.93843 106.27 9.37706 106.81 9.37706H106.815C107.355 9.37706 107.793 8.93843 107.793 8.39735V1.72604C107.793 1.18497 107.355 0.746338 106.815 0.746338Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 2.17614,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.588 0.746338H136.584C136.044 0.746338 135.605 1.18497 135.605 1.72604V8.39735C135.605 8.93843 136.044 9.37706 136.584 9.37706H136.588C137.129 9.37706 137.567 8.93843 137.567 8.39735V1.72604C137.567 1.18497 137.129 0.746338 136.588 0.746338Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 2.17614,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.767 33.6323C133.245 33.6323 134.444 32.4322 134.444 30.9519C134.444 29.4715 133.245 28.2715 131.767 28.2715C130.288 28.2715 129.09 29.4715 129.09 30.9519C129.09 32.4322 130.288 33.6323 131.767 33.6323Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 0.408026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.302 33.6323C142.78 33.6323 143.979 32.4322 143.979 30.9519C143.979 29.4715 142.78 28.2715 141.302 28.2715C139.824 28.2715 138.625 29.4715 138.625 30.9519C138.625 32.4322 139.824 33.6323 141.302 33.6323Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 0.408026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.146 33.6323C104.624 33.6323 105.823 32.4322 105.823 30.9519C105.823 29.4715 104.624 28.2715 103.146 28.2715C101.667 28.2715 100.469 29.4715 100.469 30.9519C100.469 32.4322 101.667 33.6323 103.146 33.6323Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 0.408026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.685 33.6323C114.163 33.6323 115.362 32.4322 115.362 30.9519C115.362 29.4715 114.163 28.2715 112.685 28.2715C111.206 28.2715 110.008 29.4715 110.008 30.9519C110.008 32.4322 111.206 33.6323 112.685 33.6323Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 0.408026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.224 33.6323C123.702 33.6323 124.901 32.4322 124.901 30.9519C124.901 29.4715 123.702 28.2715 122.224 28.2715C120.745 28.2715 119.547 29.4715 119.547 30.9519C119.547 32.4322 120.745 33.6323 122.224 33.6323Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 0.408026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.767 23.3899C133.245 23.3899 134.444 22.1898 134.444 20.7095C134.444 19.2291 133.245 18.0291 131.767 18.0291C130.288 18.0291 129.09 19.2291 129.09 20.7095C129.09 22.1898 130.288 23.3899 131.767 23.3899Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 0.408026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.302 23.3899C142.78 23.3899 143.979 22.1898 143.979 20.7095C143.979 19.2291 142.78 18.0291 141.302 18.0291C139.824 18.0291 138.625 19.2291 138.625 20.7095C138.625 22.1898 139.824 23.3899 141.302 23.3899Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 0.408026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.224 23.3899C123.702 23.3899 124.901 22.1898 124.901 20.7095C124.901 19.2291 123.702 18.0291 122.224 18.0291C120.745 18.0291 119.547 19.2291 119.547 20.7095C119.547 22.1898 120.745 23.3899 122.224 23.3899Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 0.408026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.767 44.4343C133.245 44.4343 134.444 43.2342 134.444 41.7539C134.444 40.2735 133.245 39.0735 131.767 39.0735C130.288 39.0735 129.09 40.2735 129.09 41.7539C129.09 43.2342 130.288 44.4343 131.767 44.4343Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 0.408026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.146 44.4343C104.624 44.4343 105.823 43.2342 105.823 41.7539C105.823 40.2735 104.624 39.0735 103.146 39.0735C101.667 39.0735 100.469 40.2735 100.469 41.7539C100.469 43.2342 101.667 44.4343 103.146 44.4343Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 0.408026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.685 44.4343C114.163 44.4343 115.362 43.2342 115.362 41.7539C115.362 40.2735 114.163 39.0735 112.685 39.0735C111.206 39.0735 110.008 40.2735 110.008 41.7539C110.008 43.2342 111.206 44.4343 112.685 44.4343Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 0.408026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.224 44.4343C123.702 44.4343 124.901 43.2342 124.901 41.7539C124.901 40.2735 123.702 39.0735 122.224 39.0735C120.745 39.0735 119.547 40.2735 119.547 41.7539C119.547 43.2342 120.745 44.4343 122.224 44.4343Z",
    fill: "#60A5FA",
    stroke: "#60A5FA",
    strokeWidth: 0.408026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.992 42.8781L138.364 46.2541L143.984 38.374M152.977 41.75C152.977 43.5228 152.629 45.2786 151.952 46.9199C151.274 48.557 150.279 50.0456 149.029 51.301C147.775 52.5564 146.289 53.5488 144.654 54.2274C143.019 54.906 141.261 55.2538 139.49 55.2538C137.72 55.2538 135.966 54.906 134.327 54.2274C132.692 53.5488 131.205 52.5522 129.952 51.301C128.698 50.0456 127.707 48.557 127.029 46.9199C126.351 45.2828 126.004 43.5228 126.004 41.75C126.004 38.1662 127.427 34.7309 129.956 32.1989C132.484 29.667 135.915 28.2419 139.495 28.2419C143.074 28.2419 146.505 29.667 149.033 32.1989C151.562 34.7309 152.985 38.1662 152.985 41.75H152.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.992 42.8781L138.364 46.2541L143.984 38.374M152.977 41.75C152.977 43.5228 152.629 45.2786 151.952 46.9199C151.274 48.557 150.279 50.0456 149.029 51.301C147.775 52.5564 146.289 53.5488 144.654 54.2274C143.019 54.906 141.261 55.2538 139.49 55.2538C137.72 55.2538 135.966 54.906 134.327 54.2274C132.692 53.5488 131.205 52.5522 129.952 51.301C128.698 50.0456 127.707 48.557 127.029 46.9199C126.351 45.2828 126.004 43.5228 126.004 41.75C126.004 38.1662 127.427 34.7309 129.956 32.1989C132.484 29.667 135.915 28.2419 139.495 28.2419C143.074 28.2419 146.505 29.667 149.033 32.1989C151.562 34.7309 152.985 38.1662 152.985 41.75H152.977Z",
    stroke: "#60A5FA",
    strokeWidth: 1.6321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5967_44777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.45f425d1c8ab49fb87cfec5c1bd145f1.svg";
export { ForwardRef as ReactComponent };